module.exports = __webpack_public_path__ + "img/video-6.0a6448f6.jpg";